import React from 'react';
import { FaPlay, FaRedo, FaArrowRight, FaHeadphones, FaTimes } from 'react-icons/fa';
import UnifiedLeaderboard from '../../ui/UnifiedLeaderboard';
import './PianoScreens.css';

/**
 * 1. Стартовый экран
 * Карточка с приглашением начать игру.
 */
export const PianoStartScreen = ({ t, onStart }) => {
  return (
    <div className="piano-overlay">
      <div className="piano-card">
        <div className="pc-title">{t('arcade.piano_start_title', 'МУЗЫКАЛЬНЫЙ ШИФР')}</div>

        <div className="pc-icon-wrapper">
           <FaHeadphones />
        </div>

        <div className="pc-subtitle">
          {t('arcade.intro_piano_desc', 'Запомните мелодию и воспроизведите её в точности.')}
        </div>

        <button className="pc-btn primary full-width" onClick={onStart}>
          <FaPlay size={14} />
          {t('arcade.piano_start_btn', 'НАЧАТЬ')}
        </button>
      </div>
    </div>
  );
};

/**
 * 2. Экран результата раунда (Всплывающее окно)
 * Показывается между уровнями. Оформлен как отчет о выполнении задания.
 */
export const PianoRoundResultScreen = ({ t, resultData, onRepeat, onNext }) => {
  if (!resultData) return null;

  const { status, points } = resultData;
  const isPositive = points > 0;

  // Определяем класс цвета для заголовка
  let statusClass = 'status-good';
  if (status === 'perfect' || status === 'almost') statusClass = 'status-perfect';
  if (status === 'fail') statusClass = 'status-fail';

  return (
    <div className="piano-overlay">
      <div className="piano-card">

        <div className="pc-subtitle" style={{marginBottom: '5px', textTransform: 'uppercase', fontSize: '11px', letterSpacing:'1px'}}>
           {t('arcade.quiz_report', 'ОТЧЕТ')}
        </div>

        <div className={`pc-status-text ${statusClass}`}>
          {t(`arcade.piano_res_${status}`)}
        </div>

        <div className={`pc-points-badge ${isPositive ? 'positive' : 'negative'}`}>
          {isPositive ? '+' : ''}{points}
        </div>

        <div className="pc-subtitle" style={{marginBottom: '25px'}}>
          {t(`arcade.piano_res_desc_${status}`)}
        </div>

        <div className="pc-btn-group">
          <button className="pc-btn secondary" onClick={onRepeat}>
            {t('arcade.piano_repeat', 'ПОВТОРИТЬ')}
          </button>
          <button className="pc-btn primary" onClick={onNext}>
            {t('arcade.piano_next', 'ДАЛЕЕ')} <FaArrowRight size={14} />
          </button>
        </div>

      </div>
    </div>
  );
};

/**
 * 3. Финальный экран
 * Показывается после окончания игры. Оформлен как финальное досье.
 */
export const PianoFinalScreen = ({ t, finalData, myId, onClose }) => {
  const myStats = finalData.my || {};

  return (
    <div className="piano-overlay">
      <div className="piano-card">

        <div className="pc-title">{t('arcade.piano_win', 'СЕАНС ЗАВЕРШЕН')}</div>

        {/* Сетка статистики */}
        <div className="pc-stats-grid">
           <div className="pc-stat-row">
              <span className="pc-stat-label">{t('arcade.wordduel_rank', 'ЗВАНИЕ')}</span>
              <span className="pc-stat-value">{t(`arcade.${myStats.rank}`)}</span>
           </div>
           <div className="pc-stat-row">
              <span className="pc-stat-label">{t('arcade.wordduel_score', 'ОЧКИ')}</span>
              <span className="pc-stat-value gold">{myStats.score}</span>
           </div>
        </div>

        {/* Таблица лидеров */}
        <div style={{width: '100%', flex: 1, minHeight: 0, overflow: 'hidden'}}>
            <UnifiedLeaderboard
                results={finalData.leaderboard}
                myId={myId}
                t={t}
            />
        </div>

        <button className="pc-btn secondary full-width" onClick={onClose} style={{marginTop: 'auto'}}>
          <FaTimes size={16} /> {t('arcade.close', 'ЗАКРЫТЬ')}
        </button>
      </div>
    </div>
  );
};